import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  public sessionKeys = {
    process: {
      line: 'selectedStatisticsline', machine: 'selectedStatisticsmachine', paramFilter: 'selectedStatisticsParameter',
      period: 'selectedStatisticsperiod', skurunperiod: 'selectedStatisticsSkurunperiod', sku: 'selectedStatisticssku',
      allSelected: 'allSelected', allParameterSelected: 'allParameterSelected'
    },
    manual: {
      line: 'selectedManualline', machine: 'selectedManualmachine', paramFilter: 'selectedManualParameter',
      period: 'selectedManualperiod', skurunperiod: 'selectedManualSkurunperiod', sku: 'selectedManualsku',
      allSelected: 'allManualSelected', allParameterSelected: 'allManualParameterSelected'
    },
    capability: {
      line: 'selectedCapabilityline', machine: 'selectedCapabilitymachine', paramFilter: 'selectedCapabilityParameter',
      period: 'selectedCapabilityperiod', skurunperiod: 'selectedCapabilitySkurunperiod', sku: 'selectedCapabilitysku',
      allSelected: 'allcapabilitySelected', allParameterSelected: 'allcapabilityParameterSelected'
    },
    dosing: {
      line: 'selectedDosingline', machine: 'selectedDosingmachine', paramFilter: 'selectedDosingParameter',
      period: 'selectedDosingperiod', skurunperiod: 'selectedDosingSkurunperiod', sku: 'selectedDosingsku',
      allSelected: 'alldosingSelected', allParameterSelected: 'alldosingParameterSelected'
    },
    xbar: {
      line: 'selectedXbarline', machine: 'selectedXbarmachine', paramFilter: 'selectedXbarParameter',
      period: 'selectedXbarperiod', skurunperiod: 'selectedXbarSkurunperiod', sku: 'selectedXbarsku',
      allSelected: 'allxbarSelected', allParameterSelected: 'allxbarParameterSelected'
    },
    summary: {
      line: 'selectedSummaryline', machine: 'selectedSummarymachine', paramFilter: 'selectedSummaryParameter',
      period: 'selectedCapabilityperiod', skurunperiod: 'selectedSummarySkurunperiod', sku: 'selectedSummarysku',
      allSelected: 'allsummarySelected', allParameterSelected: 'allsummaryParameterSelected'
    },
    deleteData: {
      line: 'selectedDeleteline', machine: 'selectedDeletemachine', paramFilter: 'selectedXbarParameter',
      period: 'selectedDeleteperiod', skurunperiod: 'selectedXbarSkurunperiod', sku: 'selectedXbarsku', type: 'selectedType',
      allSelected: 'allDeleteSelected', allParameterSelected: 'allDeleteParameterSelected', selCustmDate: 'selectedDeleteDateRange'
    },
    ga: {
      line: 'selectedgaline', machine: 'selectedgamachine', paramFilter: 'selectedgaParameter',
      period: 'selectedgaperiod', skurunperiod: 'selectedgarunperiod', sku: 'selectedgasku', allParameterSelected: 'allgaParameterSelected'
    },
    gasummary: {
      line: 'selectedgasummaryline', machine: 'selectedgasummarymachine', paramFilter: 'selectedgasummaryParameter',
      period: 'selectedsummaryperiod', skurunperiod: 'selectedgasummarySkurunperiod', sku: 'selectedgasummaryrsku', allParameterSelected: 'allgasummaryrParameterSelected'
    },
    qoPChart: {
      supp: 'selectedSupplier', mat: 'selectedMaterial', chars: 'selectedCharacters',
      period: 'selectedqoperiod', isAllMatSelect: 'isAllMatSelect', isAllCharSelect: 'isAllCharSelect'
    },
    scatter: {
      line: 'selectedgascatterline', machine: 'selectedgascattermachine', paramFilter: 'selectedgascatterParameter',
      period: 'selectedscatterperiod', skurunperiod: 'selectedgascatterSkurunperiod', sku: 'selectedgascatterrsku', allParameterSelected: 'allgascatterParameterSelected'
    },
    dashboard: {
      from: 'dashboardDateFrom', to: 'dashboardDateTo'
    },
    'statistics-continuous': {
      from: 'statisticsContinuousDateFrom', to: 'statisticsContinuousDateTo'
    },
    'capability-charts': {
      from: 'capabilityChartsDateFrom', to: 'capabilityChartsDateTo'
    },
    'i-charts': {
      from: 'iChartsDateFrom', to: 'iChartsDateTo'
    },
    'xbar-r': {
      from: 'xbarRDateFrom', to: 'xbarRDateTo'
    },
    'manual-entry': {
      from: 'manualEntryDateFrom', to: 'manualEntryDateTo'
    },
    trends: {
      from: 'trendsDateFrom', to: 'trendsDateTo'
    },
    'ga-dashboard': {
      from: 'gaDashboardDateFrom', to: 'gaDashboardDateTo'
    },
    'ga-charts': {
      from: 'gaChartsDateFrom', to: 'gaChartsDateTo'
    },
    'ga-scatter-chart': {
      from: 'gaScatterChartDateFrom', to: 'gaScatterChartDateTo'
    },
    'scatter-chart': {
      from: 'scatterChartDateFrom', to: 'scatterChartDateTo'
    },
    qo: {
      from: 'qoDateFrom', to: 'qoDateTo'
    },
    'process-chart': {
      from: 'processChartDateFrom', to: 'processChartDateTo'
    },
    compare: {
      from: 'compareDateFrom', to: 'compareDateTo'
    },
    esc: {
      from: 'escDateFrom', to: 'escDateTo'
    }
  };

  constructor() { }
  private listners = new Subject<any>();
  listen(): Observable<any> {
    return this.listners.asObservable();
  }
  sendData(send: any) {
    this.listners.next(send);
  }
}
